import { gql } from "../generated-graphql";

const GET_DOCUMENT_DOWNLOAD_LINK_QUERY = gql(`
  query GetDocumentDownloadLink($id: ID!) {
    getDocumentDownloadLink(id: $id)
  }
`);

export default GET_DOCUMENT_DOWNLOAD_LINK_QUERY;
